import { render, staticRenderFns } from "./StudentFamilyFormView.vue?vue&type=template&id=7566f338&scoped=true&"
import script from "./StudentFamilyFormView.vue?vue&type=script&lang=js&"
export * from "./StudentFamilyFormView.vue?vue&type=script&lang=js&"
import style0 from "./StudentFamilyFormView.vue?vue&type=style&index=0&id=7566f338&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7566f338",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCol,VForm,VRow,VSubheader})
